// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"BottomText_Wrapper__2eE0n","TextBlack":"BottomText_TextBlack__3-JFJ","TextOrange":"BottomText_TextOrange__23PJd","BorderLine":"BottomText_BorderLine__1jgLO"};